<script setup>
import { computed } from 'vue';
import { IconThumbDownFilled, IconThumbUpFilled } from '@tabler/icons-vue';
import AppCard from '@/Shared/AppCard.vue';

const props = defineProps({
    student: {
        type: Object,
        required: false,
    },
    team: {
        type: Object,
        required: true,
    },
});

const getStudentCompatibility = (student, team) => {
    let compatibility = {
        positive: 0,
        negative: 0,
        positive_inverse: 0,
        negative_inverse: 0,
        total: 0,
        positive_total: 0,
        negative_total: 0,
    };

    team.students.forEach((s) => {
        compatibility.positive += student.positive.includes(s.id);
        compatibility.negative -= student.negative.includes(s.id);
        compatibility.positive_inverse += s.positive.includes(student.id);
        compatibility.negative_inverse -= s.negative.includes(student.id);
    });

    compatibility.positive_total = compatibility.positive + compatibility.positive_inverse;
    compatibility.negative_total = compatibility.negative + compatibility.negative_inverse;
    compatibility.total = compatibility.positive_total + compatibility.negative_total;
    return compatibility;
};

const compatibility = computed(() => {
    return getStudentCompatibility(props.student, props.team);
});
</script>

<template>
    <div :class="student ? 'visible' : 'invisible'" class="h-10">
        <AppCard class="mt-1">
            <div class="flex gap-2 items-center" v-auto-animate>
                <div class="xh-4 xw-4">
                    <img
                        v-if="student"
                        :title="student.name_or_nickname"
                        :src="student.avatar_or_default"
                        class="relative z-30 inline-block h-4 w-4 rounded-full ring-2 ring-white"
                        alt=""
                    />
                </div>
                <div v-if="student">
                    <IconThumbUpFilled class="w-4 h-4 text-green-400 inline-block" style="color: #68d391" />
                    {{ compatibility.positive_total }}
                </div>
                <div v-if="student">
                    <IconThumbDownFilled class="w-4 h-4 text-red-400 inline-block" style="color: #fc8181" />
                    {{ compatibility.negative_total }}
                </div>
            </div>
        </AppCard>
    </div>
</template>
